<template>
  <p v-if="visible" class="mainland-access-notice" role="note">
    <span class="material-icons" aria-hidden="true">public</span>
    {{ $t('common.mainlandAccessNotice') }}
  </p>
</template>

<script>
// 中国大陆不翻墙时登录和视频都连不上。按 IP 判断不可靠，改用界面语言和设备时区：
// 中文界面，或者时区在中国大陆，就显示这条提示
const MAINLAND_TIME_ZONES = ['Asia/Shanghai', 'Asia/Urumqi', 'Asia/Chongqing', 'Asia/Harbin', 'Asia/Kashgar', 'PRC']

export default {
  name: 'MainlandAccessNotice',
  computed: {
    visible() {
      return this.$i18n.locale === 'zh'
        || MAINLAND_TIME_ZONES.includes(Intl.DateTimeFormat().resolvedOptions().timeZone)
    }
  }
}
</script>

<style scoped>
.mainland-access-notice {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  color: var(--ink-secondary);
  font-size: var(--font-size-xs);
  line-height: 1.5;
}

.mainland-access-notice .material-icons {
  flex: 0 0 auto;
  margin-top: 1px;
  color: var(--color-warning-text);
  font-size: 0.95rem;
}
</style>
